import { Effect, takeEvery } from 'redux-saga/effects';

import { ActionTypes } from '../constants';
import { createBinderDuplicate } from './createBinderDuplicate';
import { showModal } from './showModal';

const effects: Effect[] = [
  takeEvery(ActionTypes.SHOW_MODAL, showModal),
  takeEvery(ActionTypes.CREATE_BINDER_DUPLICATE, createBinderDuplicate),
];

export default effects;
